export class AzureBackupApplicationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyVaultAccessAppId",
            "baseName": "keyVaultAccessAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementAppId",
            "baseName": "managementAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupAppId",
            "baseName": "backupAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "customerTenantId",
            "baseName": "customerTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "adxClusterManagedIdentityPrincipalId",
            "baseName": "adxClusterManagedIdentityPrincipalId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureBackupApplicationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
